import { ActivityCategoryType } from '@surecompanies/activity-log'

// Type definition for activity log query parameters
export interface ActivityFilter {
  clientIds?: string[]
  actorIds?: string[]
  targetIds?: string[]
  categories?: ActivityCategoryType[]
  action?: string
  allClients?: boolean
  nullClientPublicId?: boolean
  page?: number
  limit?: number
  excludeActions?: string[]
}

export enum ActivityReasonCategory {
  QLE = 'QLE',
  ER_REQUEST = 'ER request',
  EE_REQUEST = 'EE request',
  CLEANUP = 'Cleanup',
  OTHER = 'Other',
}

export interface ActivityAdditionalData extends Record<string, unknown> {
  reason?: string
  reasonCategory?: ActivityReasonCategory
  zendeskTicket?: string
  newData?: Record<string, unknown>
  oldData?: Record<string, unknown>
}

// API Activity types (from activity log API)
export interface ApiActivity {
  id: number
  action: string
  actorClientPublicKey: string
  actorId: string
  actorName: string
  actorRole: string
  actorType: string
  additionalData: ActivityAdditionalData
  category: ActivityCategoryType
  createdOn: string
  description: string
  session: string | null
  source: string
  targetClientPublicKey: string | null
  targetId: string
  targetName: string
  targetRole: string | null
  targetType: string
  timestamp: string
  updatedOn: string
}

// API response type
export interface ActivityResponse {
  data: ApiActivity[]
  pagination?: {
    currentPage: number
    totalPages: number
    totalItems: number
    hasMore: boolean
  }
}
